import { useContext } from "react"
import { LayoutContext } from "src/admin/layout/context/layoutcontext"
import amanziLyticslogo from "../images/amanziLytics.png"
import { Button } from "primereact/button"

const Footer =()=>{

    const {layoutConfig, colors} = useContext(LayoutContext)

    return (

        <footer className="py-8 px-4 md:px-8 mt-auto"
                style={{ 
                    backgroundColor: colors.footerBg,
                    borderTop: `1px solid ${colors.borderColor}`
                }}>
            {/* Footer content remains the same */}
            <div className="grid m-0">
                {/* Company Info */}
                <div className="col-12 md:col-4 p-4">
                    <div className="flex align-items-center gap-3 mb-4">
                        <img
                            src={layoutConfig.colorScheme === "dark" ? amanziLyticslogo : amanziLyticslogo}
                            alt="AmanziLytics Logo"
                            style={{ height: "40px" }}
                        />
                        <span className="font-bold text-xl" style={{ color: colors.primaryColor }}>
                            AmanziLytics
                        </span>
                    </div>
                    <p style={{ color: colors.lightText }} className="mb-4">
                        AI-powered water intelligence platform for sustainable water management and infrastructure optimization.
                    </p>
                    <div className="flex gap-3">
                        {['pi pi-twitter', 'pi pi-facebook', 'pi pi-linkedin', 'pi pi-github'].map((icon, idx) => (
                            <Button 
                                key={idx}
                                icon={icon} 
                                text 
                                rounded 
                                severity="secondary" 
                                style={{ color: colors.textColor }}
                            />
                        ))}
                    </div>
                </div>

                {/* Footer Links */}
                {[
                    { title: "Product", links: ["Features", "Solutions", "Pricing", "API"] },
                    { title: "Company", links: ["About", "Careers", "Blog", "News"] },
                    { title: "Support", links: ["Documentation", "Help Center", "Community", "Contact"] },
                    { title: "Legal", links: ["Privacy Policy", "Terms", "Security", "Compliance"] }
                ].map((section, index) => (
                    <div key={index} className="col-6 md:col-2 p-4">
                        <h4 className="font-bold mb-4" style={{ color: colors.textColor }}>{section.title}</h4>
                        <ul className="list-none p-0 m-0">
                            {section.links.map((link, linkIndex) => (
                                <li key={linkIndex} className="mb-2">
                                    <Button
                                        label={link} 
                                        link 
                                        className="p-0 text-sm" 
                                        style={{ color: colors.lightText }}
                                    />
                                </li>
                            ))}
                        </ul>
                    </div>
                ))}
            </div>

            {/* Copyright */}
            <div className="mt-8 pt-8 border-top-1 text-center" style={{ borderColor: colors.borderColor }}>
                <p className="text-sm" style={{ color: colors.lightText }}>
                    © {new Date().getFullYear()} AmanziLytics. All rights reserved.
                </p>
                <p className="text-sm mt-2" style={{ color: colors.lightText }}>
                    Smart water management for a sustainable future.
                </p>
            </div>
        </footer>
    )
}

export default Footer